import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetHealthReady = z.any()
export type TagsGetHealthReady = z.infer<typeof tagsGetHealthReady>

export const descriptionGetHealthReady = z.any()
export type DescriptionGetHealthReady = z.infer<typeof descriptionGetHealthReady>

export const responseGetHealthReady = z.object({ "status": z.literal("ok"), "database": z.literal("connected"), "timestamp": z.string().datetime({ offset: true }) })
export type ResponseGetHealthReady = z.infer<typeof responseGetHealthReady>

interface IGetHealthReady extends BaseMethodType {
  tags: TagsGetHealthReady,
  description: DescriptionGetHealthReady,
  response: ResponseGetHealthReady
}
export const URL = '/health/ready'
export const validation = {
  get: {
    tags: tagsGetHealthReady,
    description: descriptionGetHealthReady,
    response: responseGetHealthReady
  }
}
export interface HealthReady extends BaseRouteType {
  get: IGetHealthReady
}